import React from "react";

export const PlayIcon = ({...props}) => {
  return (
    <>
      <path d="M4.57154331,24 C5.03763537,24 5.50372743,23.8714232 5.91249593,23.6223052 L5.91249593,23.6223052 L21.3417558,14.1933131 C22.1060934,13.7261493 22.5723465,12.894148 22.5723465,11.9994646 C22.5723465,11.1047819 22.1062536,10.2743877 21.3417558,9.80566997 L21.3417558,9.80566997 L5.91249593,0.376677835 C5.50158484,0.126006708 5.03742119,0 4.57207875,0 C3.09290558,0 2,1.21076864 2,2.57047242 L2,2.57047242 L2,21.4284567 C2,22.7999468 3.103621,24 4.57154331,24 Z" />
    </>
  );
};
